import yumpuIcon from "./img/yumpu.webp";
import oguloIcon from "./img/ogulo.webp";
import kameraIcon from "./img/kamera.png";
import { useConfig } from "./ConfigContext";
import { useEffect } from "react";

export default function ExterneLink({ basicdata, estateId, ownerData }) {
   const config = useConfig();

   return (
      <div>
         <div className="file-buttongroup">
            {config.company === "baur" && (
               <a
                  target="_blank"
                  className=" custom-button mb-1"
                  title="Link zum Ogulo-Rundgang"
                  rel="noopener noreferrer"
                  style={basicdata[config.estate.rundgangLink] ? {} : { pointerEvents: "none", opacity: 0.3 }}
                  href={basicdata[config.estate.rundgangLink]}
               >
                  <img src={oguloIcon} /> Rundgang ↗
               </a>
            )}
            {config.company === "baur" && (
               <a
                  target="_blank"
                  className=" custom-button mb-1 ms-1"
                  title="Link zum Yumpu-Exposé"
                  rel="noopener noreferrer"
                  style={basicdata[config.estate.exposeLink] ? {} : { pointerEvents: "none", opacity: 0.3 }}
                  href={basicdata[config.estate.exposeLink] ?? null}
               >
                  <img src={yumpuIcon} /> Exposé ↗
               </a>
            )}
         </div>
         <div className="file-buttongroup">
            {config.company === "baur" && basicdata[config.estate.oldCRMLink] && (
               <a
                  target="_blank"
                  className=" custom-button mb-1"
                  title="Link zum alten CRM-Eintrag"
                  rel="noopener noreferrer"
                  href={basicdata[config.estate.oldCRMLink]}
               >
                  altes CRM ↗
               </a>
            )}

            <a
               target="_blank"
               className=" custom-button mb-1 ms-1"
               title="Dokumentenschwärzung"
               rel="noopener noreferrer"
               // style={{ pointerEvents: "", opacity: 0.3 }}
               href={"/redact?estateid=" + estateId + "&ownerid=" + ownerData.ownerid}
            >
               {/* <img src={kameraIcon} /> */} █████████
            </a>
            <a
               target="_blank"
               className=" custom-button mb-1 ms-1"
               title="Zum Übergabeformular"
               rel="noopener noreferrer"
               // style={{ pointerEvents: "none", opacity: 0.3 }}
               // style={{ pointerEvents: "", opacity: 0.3 }}
               href={"/uebergabeformular?estateId=" + estateId}
            >
               Übergabe
            </a>
         </div>
      </div>
   );
}
